// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"12b77c156fe22f8245ec","655":"744cb1bfef16be5ba74c"}[chunkId] + ".js";
};